import methods from '@/services/methods'

export default {
  accountDetails () {
    return methods.sendGet('partners/account', null, {noHyptoLoader: true})
  },
  accountBalance (noHyptoLoader) {
    return methods.sendGet('partners/balance', null, {noHyptoLoader})
  },
  connectedBankBalance (payload) {
    return methods.sendGet(`partners/connected_bank_balance`, payload)
  },
  accountStatements (payload) {
    return methods.sendGet('transactions/list', payload, {unprivilege: 'Account Statement', noHyptoLoader: true})
  },
  filterTxnsCount (payload) {
    return methods.sendGet('transactions/filter_txn_count', payload)
  },
  exportStatements (payload) {
    return methods.sendGet('transactions/export', payload)
  },
  search (payload) {
    return methods.sendGet('transactions/search', payload, {restrictToast: true, unprivilege: 'Account Statement', noHyptoLoader: true})
  },
  transactionStatus (id) {
    return methods.sendGet(`transactions/${id}/status`)
  },
  resendWebhook (id) {
    return methods.sendPost(`transactions/${id}/resend_webhook`)
  },
  resendEmail (id) {
    return methods.sendPost(`transactions/${id}/resend_email`)
  },
  bulkResendWebhook (payload) {
    return methods.sendPost(`transactions/bulk_resend_webhook`, payload)
  },
  selectFields (payload) {
    return methods.sendPost(`settings/transaction_fields`, payload)
  }
}
